<script lang="ts">
  import type { SalesRep } from "@shared/types/SalesRep";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  export let element;
  const rep: SalesRep = element.label;

</script>

<div
  class="fizz-flex-row-8 fizz-align-content-start fizz-highlight-on-hover fizz-inset-squish-16 cursor-pointer"
>
  <Icon type="Contact" height="16" width="16" fill="currentColor" />
  <!-- class added for style overrides from parent component -->
  <p class="sales-rep-info">
    <strong>{rep.name}</strong><br />
    <span class="fizz-text-subdued">
      {rep.contact_phone ? rep.contact_phone + " · " : ""}
      {rep.contact_email}
    </span>
  </p>
</div>
